var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatMessageBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 924,
    height: 946,
    viewBox: "0 0 924 946",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1078_8004)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 923,
    height: 946,
    transform: "translate(0.302002)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-122.156 82.2135C68.5012 120.015 173.298 177.809 234.564 226.413C285.636 266.935 285.727 284.637 339.22 314.036C455.306 377.832 673.042 414.372 774.055 348.68C823.814 316.32 802.787 279.864 823.512 207.572C842.157 142.541 894.546 51.652 1048.91 -52.3994",
    stroke: "url(#paint0_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-120.942 97.6737C64.2094 129.008 167.789 183.108 228.845 228.394C280.219 266.51 285.099 282.6 341.78 311.272C460.685 371.419 665.22 406.703 766.596 345.023C818.815 313.255 804.587 277.073 829.541 204.761C851.512 141.099 905.149 51.6482 1056.81 -51.3986",
    stroke: "url(#paint1_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-119.728 113.131C59.9151 138.001 162.357 188.418 223.137 230.374C274.917 266.117 284.384 280.569 344.352 308.506C465.825 365.096 657.726 399.124 759.155 341.367C813.948 310.162 806.312 274.323 835.586 201.952C860.781 139.678 915.766 51.6496 1064.74 -50.3889",
    stroke: "url(#paint2_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-118.513 128.591C55.6211 146.997 157.024 193.738 217.43 232.367C269.681 265.761 283.572 278.559 346.936 305.737C470.749 358.871 650.544 391.649 751.721 337.708C809.207 307.063 807.955 271.608 841.64 199.139C869.928 138.277 926.394 51.6507 1072.65 -49.3846",
    stroke: "url(#paint3_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117.297 144.049C51.3445 155.985 151.807 199.052 211.723 234.337C264.537 265.436 282.704 276.571 349.488 302.973C475.435 352.748 643.615 384.289 744.257 334.051C804.555 303.954 809.47 268.917 847.665 196.329C878.945 136.888 936.996 51.6514 1080.54 -48.3682",
    stroke: "url(#paint4_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-116.084 159.507C47.0356 164.979 146.714 204.361 206.014 236.317C259.5 265.14 281.713 274.62 352.058 300.205C479.958 346.729 636.958 377.045 736.808 330.395C800.03 300.856 810.872 266.244 853.705 193.517C887.86 135.502 947.609 51.6531 1088.45 -47.3748",
    stroke: "url(#paint5_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-114.87 174.965C42.7397 173.962 141.768 209.64 200.306 238.298C254.581 264.869 280.667 272.706 354.625 297.44C484.33 340.814 630.532 369.927 729.359 326.738C795.612 297.782 812.202 263.576 859.745 190.709C896.67 134.113 958.235 51.6545 1096.35 -46.3678",
    stroke: "url(#paint6_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-113.642 190.425C38.4592 182.964 136.999 214.887 194.611 240.278C249.813 264.607 279.583 270.838 357.206 294.674C488.583 335.003 624.331 362.933 721.924 323.079C791.315 294.744 813.415 260.911 865.799 187.897C905.372 132.72 968.836 51.6641 1104.26 -45.363",
    stroke: "url(#paint7_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-112.442 205.883C34.1506 191.958 132.376 220.078 188.889 242.26C245.176 264.346 278.39 269.035 359.763 291.907C492.714 329.292 618.29 356.067 714.462 319.424C787.1 291.754 814.487 258.23 871.826 185.086C913.981 131.312 979.449 51.6571 1112.19 -44.3599",
    stroke: "url(#paint8_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-111.228 221.335C29.8596 200.944 127.943 225.187 183.181 244.234C240.683 264.06 277.172 267.255 362.331 289.135C496.753 323.67 612.399 349.317 707.014 315.76C782.973 288.819 815.463 255.523 877.866 182.268C922.498 129.878 990.066 51.6523 1120.08 -43.361",
    stroke: "url(#paint9_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-110.013 236.801C25.5823 209.943 123.689 230.219 177.477 246.221C236.367 263.743 275.917 265.557 364.902 286.374C500.74 318.152 606.644 342.705 699.566 312.11C778.942 285.975 816.326 252.798 883.907 179.463C930.928 128.437 1000.68 51.6606 1127.99 -42.3459",
    stroke: "url(#paint10_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-108.798 252.26C21.2709 218.936 119.602 235.132 171.769 248.201C232.211 263.346 274.642 263.915 367.469 283.609C504.679 312.714 600.994 336.203 692.118 308.453C774.991 283.216 817.084 250.03 889.948 176.654C939.289 126.963 1011.29 51.6608 1135.9 -41.3431",
    stroke: "url(#paint11_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-107.585 267.719C16.9758 227.929 115.657 239.916 166.061 250.184C228.204 262.842 273.311 262.332 370.04 280.843C508.589 307.357 595.418 329.817 684.672 304.794C771.099 280.564 817.741 247.217 895.988 173.842C947.583 125.459 1021.91 51.6624 1143.81 -40.339",
    stroke: "url(#paint12_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-106.37 283.178C12.6849 236.922 111.832 244.56 160.353 252.164C224.33 262.19 271.977 260.813 372.601 278.076C512.472 302.073 589.888 323.53 677.217 301.139C767.286 278.034 818.293 244.35 902.022 171.032C955.825 123.923 1032.52 51.658 1151.72 -39.3279",
    stroke: "url(#paint13_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-105.156 298.635C8.38957 245.914 108.078 249.057 154.631 254.145C220.532 261.345 270.619 259.355 375.164 275.311C516.355 296.859 584.385 317.369 669.762 297.482C763.511 275.644 818.76 241.425 908.055 168.214C964.003 122.346 1043.12 51.6583 1159.61 -38.3358",
    stroke: "url(#paint14_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-103.942 314.095C4.11235 254.906 104.352 253.406 148.937 256.124C216.801 260.263 269.282 257.958 377.745 272.543C520.253 291.716 578.908 311.296 662.327 293.825C759.792 273.408 819.163 238.444 914.11 165.41C972.177 120.745 1053.75 51.6658 1167.53 -37.3234",
    stroke: "url(#paint15_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-102.711 329.553C-0.182882 263.9 101.495 265.343 143.245 258.106C211.534 246.266 267.951 256.623 380.333 269.776C524.177 286.616 573.401 305.32 654.878 290.167C756.082 271.353 819.483 235.379 920.15 162.599C980.304 119.107 1064.37 51.6679 1175.44 -36.3104",
    stroke: "url(#paint16_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101.513 345.012C-4.48982 272.894 98.0584 268.046 137.521 260.087C206.689 246.139 266.591 255.349 382.884 267.012C528.119 281.585 567.84 299.439 647.431 286.51C752.374 269.476 819.744 232.252 926.191 159.784C988.417 117.424 1074.98 51.6635 1183.35 -35.3185",
    stroke: "url(#paint17_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-100.299 360.471C-8.7852 281.885 94.1384 270.527 131.813 262.067C202.139 246.277 265.256 254.132 385.455 264.255C532.085 276.593 562.217 293.632 639.983 282.864C748.648 267.817 819.951 229.061 932.232 156.987C996.513 115.725 1085.6 51.6756 1191.26 -34.2995",
    stroke: "url(#paint18_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-99.0845 375.929C-13.0795 290.878 88.3397 269.635 126.108 264.047C200.503 253.058 263.945 252.968 388.026 261.485C536.099 271.639 556.506 287.893 632.538 279.202C744.876 266.354 820.113 225.77 938.279 154.164C1004.61 113.964 1096.22 51.6707 1199.17 -33.3059",
    stroke: "url(#paint19_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-97.8702 391.387C-17.3741 299.872 83.8101 273.532 120.397 266.03C195.619 250.607 262.644 251.86 390.59 258.718C540.142 266.727 550.676 282.226 625.086 275.544C741.035 265.134 820.246 222.433 944.313 151.36C1012.7 112.182 1106.82 51.6774 1207.08 -32.2948",
    stroke: "url(#paint20_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-96.6562 406.848C-21.6656 308.865 78.9583 277.452 114.689 268.011C190.293 248.027 261.369 250.802 393.16 255.948C544.237 261.846 544.72 276.615 617.641 271.884C737.097 264.127 820.349 219.008 950.357 148.547C1020.8 110.369 1117.44 51.6732 1214.99 -31.2944",
    stroke: "url(#paint21_linear_1078_8004)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1078_8004",
    x1: 461.457,
    y1: -20.5996,
    x2: 483.776,
    y2: 391.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1078_8004",
    x1: 465.633,
    y1: -19.3973,
    x2: 487.539,
    y2: 385.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1078_8004",
    x1: 469.823,
    y1: -18.1854,
    x2: 491.318,
    y2: 378.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1078_8004",
    x1: 474.005,
    y1: -16.9793,
    x2: 495.096,
    y2: 372.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1078_8004",
    x1: 478.179,
    y1: -15.7616,
    x2: 498.868,
    y2: 366.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1078_8004",
    x1: 482.359,
    y1: -14.5664,
    x2: 502.654,
    y2: 360.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1078_8004",
    x1: 486.539,
    y1: -13.3578,
    x2: 506.442,
    y2: 354.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1078_8004",
    x1: 490.727,
    y1: -12.1515,
    x2: 510.245,
    y2: 348.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1078_8004",
    x1: 494.91,
    y1: -10.9457,
    x2: 514.047,
    y2: 342.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1078_8004",
    x1: 499.082,
    y1: -9.74557,
    x2: 517.843,
    y2: 336.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1078_8004",
    x1: 503.265,
    y1: -8.52867,
    x2: 521.654,
    y2: 331.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1078_8004",
    x1: 507.445,
    y1: -7.32414,
    x2: 525.467,
    y2: 325.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1078_8004",
    x1: 511.626,
    y1: -6.11824,
    x2: 529.286,
    y2: 320.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1078_8004",
    x1: 515.807,
    y1: -4.9054,
    x2: 533.108,
    y2: 314.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1078_8004",
    x1: 519.981,
    y1: -3.71183,
    x2: 536.93,
    y2: 309.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1078_8004",
    x1: 524.169,
    y1: -2.49741,
    x2: 540.768,
    y2: 304.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1078_8004",
    x1: 528.359,
    y1: -1.283,
    x2: 544.613,
    y2: 298.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1078_8004",
    x1: 532.531,
    y1: -0.0889361,
    x2: 549.305,
    y2: 309.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1078_8004",
    x1: 536.713,
    y1: 1.13187,
    x2: 554.247,
    y2: 325.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1078_8004",
    x1: 540.895,
    y1: 2.32728,
    x2: 559.189,
    y2: 340.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1078_8004",
    x1: 545.075,
    y1: 3.5401,
    x2: 564.13,
    y2: 355.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1078_8004",
    x1: 549.257,
    y1: 4.74235,
    x2: 569.072,
    y2: 370.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376041,
    stopColor: "#BA91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#F25DE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1078_8004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 923,
    height: 946,
    fill: "white",
    transform: "translate(0.302002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMessageBg);
export default __webpack_public_path__ + "static/media/chatMessageBg.d0801f52de4e4b4a48cb6e9432c4b956.svg";
export { ForwardRef as ReactComponent };